(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('CheckoutJointProfileForm', [
			'$filter',
			'$document',
			'Big',
			'globalConfig',
			'US_STATES',
			CheckoutJointProfileFormFunction
		]);

	function CheckoutJointProfileFormFunction(
		$filter,
		$document,
		Big,
		globalConfig,
		US_STATES
	) {

		var checkout = this;
		
		checkout.formValues = globalConfig.formValues;
		checkout.jointAccountTypes = globalConfig.jointAccountTypes;
		checkout.states = US_STATES;
		checkout.formValues.jointAccountType = $filter('findSelectedOption')(checkout.formValues.jointAccountType, 'value', checkout.jointAccountTypes);
		checkout.formValues.state = $filter('findSelectedOption')(checkout.formValues.state, 'abbreviation', checkout.states);
		checkout.formValues.secondPartyState = $filter('findSelectedOption')(checkout.formValues.secondPartyState, 'abbreviation', checkout.states);
		
		checkout.updateSecondPartyPercentageOwnership = function(){
			if (angular.isDefined(checkout.formValues.firstPartyPercentageOwnership)) {
				var firstPartyOwnership = new Big(checkout.formValues.firstPartyPercentageOwnership);
				var total = new Big(100);
				
				checkout.secondPartyPercentOwnership = total.minus(firstPartyOwnership).toFixed(0);
			} else {
				checkout.secondPartyPercentOwnership = '';
			}
		};

		checkout.validateStateDropdownAndSubmit = function(){
			if (checkout.formValues.jointAccountType.value === 'COMMUNITY_PROPERTY') {
				validateCommunityPropertySubmission();
			} else {
				submitJointProfileForm();
			}
		};

		checkout.resetStateDropdownValidity = function(){
			checkout.jointAccountForm.state.$setValidity('required', true);
			
			if (!checkout.formValues.secondPartyAddressIsSame) {
				checkout.jointAccountForm.secondPartyState.$setValidity('required', true);
			}
		};

		checkout.resetFormSubmit = function() {
			checkout.formSubmitted = false;
		};
		
		function validateCommunityPropertySubmission(){
			var validStates = ['AA', 'AE', 'AP', 'AZ', 'CA', 'ID', 'LA', 'NM', 'NV', 'TX', 'WA', 'WI'];
			var firstPartyStateIsValid = validStates.indexOf(checkout.formValues.state.abbreviation) !== -1;

			if (!checkout.formValues.secondPartyAddressIsSame) {
				var secondPartyStateIsValid = validStates.indexOf(checkout.formValues.secondPartyState.abbreviation) !== -1;

				if (firstPartyStateIsValid && secondPartyStateIsValid) {
					submitJointProfileForm();
				} else {
					checkout.jointAccountForm.state.$setTouched();
					checkout.jointAccountForm.state.$setValidity('required', firstPartyStateIsValid);
					checkout.jointAccountForm.secondPartyState.$setTouched();
					checkout.jointAccountForm.secondPartyState.$setValidity('required', secondPartyStateIsValid);
					checkout.resetFormSubmit();
				}
			} else {
				if (firstPartyStateIsValid) {
					submitJointProfileForm();
				} else {
					checkout.jointAccountForm.state.$setTouched();
					checkout.jointAccountForm.state.$setValidity('required', firstPartyStateIsValid);
					checkout.resetFormSubmit();
				}
			}
		}

		function submitJointProfileForm(){
			$document[0].getElementById('jointAccountForm').submit();
		}
	}
})(window.angular);